var chunkMapping = {
	"544": [
		8970,
		17693,
		33457,
		48845,
		49283,
		66467,
		80137,
		98520
	],
	"576": [
		29684,
		30828,
		36744,
		45620,
		49518,
		52391,
		55894,
		73580
	]
};
var idToExternalAndNameMapping = {
	"8970": [
		"default",
		"./isAuthorized",
		41441
	],
	"17693": [
		"default",
		"./Selectors",
		41441
	],
	"29684": [
		"default",
		"./UnboxingPageCrossSelling",
		96308
	],
	"30828": [
		"default",
		"./UnboxingPageIntroduction",
		96308
	],
	"33457": [
		"default",
		"./Utils",
		77672
	],
	"36744": [
		"default",
		"./UnboxingPage",
		96308
	],
	"45620": [
		"default",
		"./UnboxingPageRow",
		96308
	],
	"48845": [
		"default",
		"./Store",
		77672
	],
	"49283": [
		"default",
		"./unboxing-page",
		96308
	],
	"49518": [
		"default",
		"./UnboxingPageDocumentation",
		96308
	],
	"52391": [
		"default",
		"./UnboxingPageHeader",
		96308
	],
	"55894": [
		"default",
		"./UnboxingPageCol",
		96308
	],
	"66467": [
		"default",
		"./hooks",
		41441
	],
	"73580": [
		"default",
		"./UnboxingPageBody",
		96308
	],
	"80137": [
		"default",
		"./register",
		41757
	],
	"98520": [
		"default",
		"./Selectors",
		77672
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}